import { all, put, takeEvery } from 'redux-saga/effects'
import moment from 'moment'
import _ from 'lodash'

import config from '../../../../../../../../../config'

import { BLOCK_DATA_LOADED } from '../../../../../../../components/Workspace/components/HocBlock/constants'
import { blockDataTransformed } from '../../../../../../../components/Workspace/components/HocBlock/actions'

function* onDataLoaded(_action) {
    const blockKey = _.get(_action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.certificates.key) return null

    const module = _.get(_action, 'data.module', null)
    const id = _.get(_action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const data = _.get(_action, 'data.data', null)

    const transformedData = {
        title: _.get(data, 'title', ''),
        rowsCount: data && data.certificates ? data.certificates.length : 0,
        noData: _.isEmpty(data),
        certificatesTable: {
            _table: [
                {
                    key: 'certificates',
                    tables: [
                        {
                            nested: false,
                            rows: _.map(data.certificates, (certificate) => ({
                                text: {
                                    name: certificate.name,
                                    publisher: certificate.rootName,
                                },
                                startDate:
                                    certificate.startDate &&
                                    moment(_.get(certificate, 'startDate.value', null)).format('DD.MM.YYYY'),
                            })),
                        },
                    ],
                },
            ],
        },
    }

    yield put(blockDataTransformed(module, id, blockKey, transformedData))

    return null
}

export default function* blockTransformSaga() {
    yield all([takeEvery(BLOCK_DATA_LOADED, onDataLoaded)])
}
